import { useState } from "react";
import { Box } from "../box";
import "./Avatar.css";

const Avatar = (props: {
  url: string;
  height?: string;
  width?: string;
  componentKey: string;
  expand?: boolean;
  name?: string;
}): JSX.Element => {
  const { url, height, width, componentKey, expand, name } = props;
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [imageError, setImageError] = useState<boolean>(false);


  //functions
  const handleExpand = () => {
    if (expand) {
      setIsExpanded(!isExpanded);
    }
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageError(false);
  };
  return (
    <>
      {url && !imageError ? (
        <Box
          className={`avatar-component-parent ${
            isExpanded ? "avatar-component-parent-expanded" : ""
          }`}
          onClick={handleExpand}
        >
          <Box
            height={height}
            width={width}
            className={`avatar-component-container ${
              isExpanded ? "avatar-component-container-expanded" : ""
            }`}
            key={componentKey}
            transition={
              !isExpanded
                ? "height 0.25s ease, width 0.25s ease, border-radius 0.25s ease, box-shadow 0.25s ease"
                : ""
            }
            style={{
              overflow: 'hidden',
              position: 'relative'
            }}
          >
            <img
              src={url}
              alt={name || 'Profile'}
              onError={handleImageError}
              onLoad={handleImageLoad}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '50%'
              }}
            />
          </Box>
        </Box>
      ) : (
        <Box
          height={height}
          width={width}
          className="default-avatar"
          background={!name ? "white" : ""}
        >
          {name ? name[0]?.toUpperCase() : ""}
        </Box>
      )}
    </>
  );
};

export default Avatar;
